module.exports = __webpack_public_path__ + "static/media/green-plus.b070d0ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green-plus.svg
// module id = 1956
// module chunks = 1